import { useEffect, useState } from 'react';

// One shared company lens across Projects, Cost Ledger and Cost Inbox.
// Picking a company on any of them applies everywhere (persists between sessions).
const KEY = 'lux.companyLens';
export const COMPANY_LENS = ['all', 'DEV', 'CON'];

export function useCompanyLens() {
  const [companyView, setCompanyView] = useState(() => {
    try { const v = localStorage.getItem(KEY); return COMPANY_LENS.includes(v) ? v : 'all'; } catch { return 'all'; }
  });

  useEffect(() => {
    try { localStorage.setItem(KEY, companyView); } catch { /* ignore */ }
  }, [companyView]);

  // Stay in sync when another tab changes the lens.
  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY && COMPANY_LENS.includes(e.newValue)) setCompanyView(e.newValue); };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return [companyView, setCompanyView];
}
